import { Breakpoint, useMediaQuery, useTheme } from "@mui/material";

type BreakpointAction = "up" | "down";

type MUIBreakPoints = Breakpoint | number;

interface Props {
  action: BreakpointAction;
  breakpoint: MUIBreakPoints;
}

const useThemeBreakPoints = ({ breakpoint, action }: Props) => {
  const theme = useTheme();

  const isMatched = useMediaQuery(theme.breakpoints[action](breakpoint));

  return { isMatched };
};

export default useThemeBreakPoints;
